// TODO: to be removed with PAY_3067_ENHANCE_MILEAGE_EXPENSE_ITEMS
// LEGACY MILEAGE-LOCK group; see RequestMileageConfiguration.ts
import { type RequestMileageConfiguration } from '@webapp/modules/expense/entities/RequestMileageConfiguration'
import { useQueryMileageConfiguration } from '../models/useQueryMileageConfiguration'

interface UseGetRequestMileageConfigurationPresenterReturn {
  data: {
    mileageConfiguration: RequestMileageConfiguration | null
  }
  states: {
    isLoading: boolean
    isError: boolean
  }
}

export const useGetRequestMileageConfigurationPresenter =
  (): UseGetRequestMileageConfigurationPresenterReturn => {
    const { mileageConfiguration, isLoading, isError } =
      useQueryMileageConfiguration()

    return {
      data: {
        mileageConfiguration,
      },
      states: {
        isLoading,
        isError,
      },
    }
  }
